const CNPJ_FIRST_DV_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_SECOND_DV_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const CNPJ_BLACKLIST = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
];

const charValueForCnpj = (char) => String(char).toUpperCase().charCodeAt(0) - 48;

const calcCnpjCheckDigit = (chars, weights) => {
  const sum = [...chars].reduce(
    (acc, char, index) => acc + charValueForCnpj(char) * weights[index],
    0,
  );
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCnpj = (normalized) => {
  if (!normalized || normalized.length !== 14) {
    return false;
  }

  const upper = normalized.toUpperCase();

  if (!/^[0-9A-Z]{12}\d{2}$/.test(upper)) {
    return false;
  }

  if (CNPJ_BLACKLIST.includes(upper)) {
    return false;
  }

  const base = upper.slice(0, 12);
  const firstDigit = calcCnpjCheckDigit(base, CNPJ_FIRST_DV_WEIGHTS);
  const withFirstDigit = `${base}${firstDigit}`;
  const secondDigit = calcCnpjCheckDigit(withFirstDigit, CNPJ_SECOND_DV_WEIGHTS);
  const expected = `${withFirstDigit}${secondDigit}`;

  return upper === expected;
};

export const normalizeTaxIdentifier = (value) => (
  (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
);

export const isValidCpf = (normalized) => {
  if (!normalized || normalized.length !== 11 || !/^\d{11}$/.test(normalized)) {
    return false;
  }

  if (
    normalized === '00000000000'
    || normalized === '11111111111'
    || normalized === '22222222222'
    || normalized === '33333333333'
    || normalized === '44444444444'
    || normalized === '55555555555'
    || normalized === '66666666666'
    || normalized === '77777777777'
    || normalized === '88888888888'
    || normalized === '99999999999'
  ) {
    return false;
  }

  let add = 0;
  for (let i = 0; i < 9; i += 1) {
    add += parseInt(normalized.charAt(i), 10) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(normalized.charAt(9), 10)) {
    return false;
  }

  add = 0;
  for (let i = 0; i < 10; i += 1) {
    add += parseInt(normalized.charAt(i), 10) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }

  return rev === parseInt(normalized.charAt(10), 10);
};

export const isValidTaxIdentifier = (normalized, { allowCpf = true, allowCnpj = true } = {}) => {
  if (!normalized) {
    return false;
  }

  const value = normalized.toUpperCase();

  if (allowCpf && value.length === 11) {
    return isValidCpf(value);
  }

  if (allowCnpj && value.length === 14) {
    return isValidCnpj(value);
  }

  return false;
};
